import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, retry } from '@reduxjs/toolkit/query/react'
import { RootState } from '../app/store';
import { API_URL } from '../constants/api';
import { logout, tokensReceived } from '../features/users/usersSlice';
import { ServerJWTAuthorization } from '../types';
import { RETRY_ATTEMPTS } from 'constants/api';


const refreshBaseQuery = fetchBaseQuery({
  baseUrl: API_URL,
})

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const token = (getState() as RootState).users.authorization?.accessToken
    const tokenType = (getState() as RootState).users.authorization?.tokenType
    if (token) {
      headers.set('Authorization', `${tokenType} ${token}`);
    }
    return headers
  },
})

const baseQueryWithHandling: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)
  if (result.error) {
    const { status, data } = result.error;

    if (status === 401 && (data as any)?.code == 'token_not_valid') {
      // try to refresh token
      const refreshToken = (api.getState() as RootState).users.authorization?.refreshToken;
      const refreshResult = await refreshBaseQuery({
        url: `/auth/refresh/`,
        method: 'POST',
        body: {
          refresh: refreshToken,
        },
      }, api, extraOptions)
      if (refreshResult.data) {
        // store the new token
        api.dispatch(tokensReceived(refreshResult.data as ServerJWTAuthorization))
        // retry the initial query
        result = await baseQuery(args, api, extraOptions)
      } else {
        api.dispatch(logout())
      }
    }
    if (status === 401 && (data as any)?.detail === 'Realm not selected') {
      // redirect user to realm selection page
      api.dispatch({ type: 'nav/redirect', payload: '/select-realm' })
    }
    // if (status === 401 && (data as any)?.detail === 'Authentication credentials were not provided.') {
    //   // redirect user to realm selection page
    //   api.dispatch({ type: 'nav/redirect', payload: '/sign-in/' })
    // }
  }
  return result
}

const baseQueryWithRetry = retry(baseQueryWithHandling, { maxRetries: RETRY_ATTEMPTS })

export const api = createApi({
  reducerPath: 'splitApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: ['BoardingPasses', 'Users', 'Coupons', 'StoreCards', 'EventTickets', 'GenericPasses', 'Scenarios', 'CreatedPasses', 'StampCoupons', 'StampCouponTransactions', 'Memberships', 'MembershipTransactions', 'TemplateStatistics', 'PricingPlans', ],
  endpoints: () => ({}),
})
  